import { PUSHER_SCRIPT_SELECTOR, PUSHER_SDK_URL, type PusherWindow } from '../../consts/pusher/sdk';
import { getPusherConstructor } from './getSdk';

export function loadPusherSdk() {
  const pusherWindow = window as PusherWindow;
  if (getPusherConstructor()) {
    return Promise.resolve();
  }
  if (pusherWindow.__UA_PUSHER_SDK_LOADING__) {
    return pusherWindow.__UA_PUSHER_SDK_LOADING__;
  }

  pusherWindow.__UA_PUSHER_SDK_LOADING__ = new Promise<void>((resolve, reject) => {
    const handleError = (failedScript: HTMLScriptElement) => () => {
      failedScript.remove();
      pusherWindow.__UA_PUSHER_SDK_LOADING__ = undefined;
      reject(new Error('Failed to load Pusher SDK'));
    };
    const existingScript = document.querySelector<HTMLScriptElement>(PUSHER_SCRIPT_SELECTOR);
    if (existingScript) {
      if (existingScript.dataset.uaPusherLoaded === 'true') {
        resolve();
        return;
      }
      existingScript.addEventListener('load', () => resolve(), { once: true });
      existingScript.addEventListener('error', handleError(existingScript), { once: true });
      return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.dataset.uaPusherSdk = 'true';
    script.src = PUSHER_SDK_URL;
    script.onload = () => {
      script.dataset.uaPusherLoaded = 'true';
      resolve();
    };
    script.onerror = handleError(script);
    document.head.appendChild(script);
  });

  return pusherWindow.__UA_PUSHER_SDK_LOADING__;
}
